<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m12.1 2.5.6.2h.1l.4.5 2.1 4.3a1 1 0 0 0 .8.5l4.7.7.6.3h.1v.1a1.4 1.4 0 0 1 0 2l-3.3 3.3a1 1 0 0 0-.3.9l.8 4.6a1.4 1.4 0 0 1-.6 1.3 1 1 0 0 1-1.4.1l-4.2-2.1a1 1 0 0 0-1 0l-4.2 2.1a1.4 1.4 0 0 1-2-.7V20l.8-4.6V15l-.3-.7L2.4 11a1.4 1.4 0 0 1 .1-2l.6-.3h.1L7.9 8a1 1 0 0 0 .8-.5l2-4.2q.2-.4.6-.6zm-1.8 5.8A3 3 0 0 1 8 9.8l-3.8.6L7.1 13a3 3 0 0 1 .8 2.5l-.7 3.7 3.5-1.7.1-.1a3 3 0 0 1 2.4 0h.1l3.5 1.8-.7-3.7a3 3 0 0 1 .8-2.5l2.8-2.7-3.8-.6a3 3 0 0 1-2.2-1.5L12 4.8zM20.6 10"
    />
  </svg>
</template>
